import { useCallback, useState } from 'react'
import { AccionEjecutar } from '../types'
import { BaseResponseFields, QueryStatus } from 'src/types'
import { HttpSistema } from '../api/httpSistema'

// TODO: agregar callbacks on success, on error, etc
// TODO: archivo de errores estandarizados

// TODO: crear mensajes de error personalizados, y que los hooks devuelvan errores
// descriptivos, así se puede pasar el mensaje ése a toasts, alerts, etc...

export const useEjecutarAccion = (idMensaje: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

    const onClickEjecutar = useCallback(
        (accionEjecutar: AccionEjecutar) => {
            // validar cosas
            return new Promise<string>((resolve, reject) => {
                HttpSistema.ejecutarAccion(idMensaje, accionEjecutar)
                    .then(value => {
                        if (value[BaseResponseFields.HasError]) {
                            reject(value[BaseResponseFields.ErrorDescription])
                            setStatus(QueryStatus.Error)
                        } else {
                            resolve('Enviado')
                            setStatus(QueryStatus.Success)
                        }
                    })
                    .catch(e => {
                        setStatus(QueryStatus.Error)
                        reject(e[BaseResponseFields.ErrorDescription])
                        console.log('Error ejecutar acción: ', e)
                    })
            })
        },
        [idMensaje]
    )

    return { onClickEjecutar, status }
}
